import { useEffect, useState } from "react";
import AttendanceEmployeeFilter from "../../../components/AttendanceEmployeeFilter";
import { useSelector } from "react-redux";
import { attendanceUpdateAsync, fetchAllRecordsAsync } from "../../../Slices/Thunk/LoginThunk";
import { useDispatch } from "react-redux";
import moment from "moment";
import { AntdButton } from "../../../blueplanitUtils/InputField";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import { attendenceLoginThunk } from "../../../Slices/Thunk/LoginThunk";
import { setPunchInStatus } from "../../../Slices/loginUserSlice";
import useElapsedTime from "./punchinTimer";
import dayjs from "dayjs";


const AttendanceEmployee = () => {
  const [activity, setActivity] = useState([]);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const UserStatus = useSelector((state) => state?.loginUserInfo?.punchinStatus);
  const allRecords = useSelector((state) => state.Attendence.AllRecords);
  const lastAttendenceRecord = useSelector((state) => state.Attendence.attendence);
  const progress = useSelector((state) => state.Attendence.progress);
  const progressBar = progress?.response;
  const totalCount = useSelector((state) => state.Attendence.totalRecords);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const dispatch = useDispatch();
  const recordsToDisplay = allRecords;
  const formatDuration = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }
    return `${seconds}s`;
  };

  const handleTableChange = ({ current, pageSize }) => {
    setPage(current);  
    setPageSize(pageSize);
  };

  useEffect(() => {
    dispatch(fetchAllRecordsAsync({ userId: loginUser?.id, page, pageSize}));
  }, [dispatch, loginUser?.id, page, pageSize])

  const formatAttendanceData = (allRecords) => {
    return allRecords?.map((acc) => {
      const punchIn = parseInt(acc.punchIn);
      const punchOut = acc.punchOut ? parseInt(acc.punchOut) : null;

      const durationMs = punchOut ? punchOut - punchIn : 0;
      const durationHours = durationMs / (1000 * 60 * 60);

      let totalBreakMs = 0;

      if (acc.breaks?.length > 0) {
        acc.breaks.forEach((b) => {
          if (b.breakIn && b.breakOut) {
            const inTime = parseInt(b.breakIn);
            const outTime = parseInt(b.breakOut);
            totalBreakMs += (outTime - inTime);
          }
        });
      }

      const breakHours = totalBreakMs / (1000 * 60 * 60);
      const workHoursExcludingBreak = durationHours - breakHours;
      const overtime = workHoursExcludingBreak > 9 ? workHoursExcludingBreak - 9 : 0;

      return {
        id: acc.id,
        Date: moment(punchIn).format("DD/MM/YYYY"),
        PunchIn: moment(punchIn).format("hh:mm A"),
        PunchOut: punchOut ? moment(punchOut).format("hh:mm A") : "--",
        Break: formatDuration(totalBreakMs),
        Overtime: `${overtime.toFixed(2)} hrs`,
        breaksDetail: acc.breaks,
      };
    });
  };

  const column = [
    { title: "S.No", dataIndex: "SNo", key: "SNo" },
    { title: "Date", dataIndex: "Date", key: "Date" },
    { title: "Punch In", dataIndex: "PunchIn", key: "PunchIn" },
    { title: "Punch Out", dataIndex: "PunchOut", key: "PunchOut", render: (text) => text || "--" },
    { title: "Break In/Out", dataIndex: "Break", key: "Break", render: (text) => text || "--" },
    { title: "Overtime", dataIndex: "Overtime", key: "Overtime", render: (text) => text || "--" },
  ];

  const userElements = formatAttendanceData(recordsToDisplay)?.map((user, index) => ({
    SNo: (page - 1) * pageSize + index + 1,
    ...user,
  }));



  const elapsedString = useElapsedTime(UserStatus); 

const [h, m, s] = elapsedString.split(':').map(Number);

const elapsedHours = h + (m / 60) + (s / 3600);

const formatHours = (decimalHours) => {
  const hours = Math.floor(decimalHours);
  const minutes = Math.floor((decimalHours - hours) * 60);
  return `${hours}h ${minutes}m`;
};

  const calcPercent = (baseHours, targetHours) => {
    return Math.min(((Number(baseHours) + elapsedHours) / targetHours) * 100, 100);
  };

  const progressData = progressBar
    ? [
      {
        title: "Today",
        value: formatHours(Number(progressBar.today.hours) + elapsedHours),
        valuespan: ` / ${progressBar.today.targetHours} hrs`,
        progressBarColor: "bg-success",
        progressWidth: `${calcPercent(progressBar.today.hours, progressBar.today.targetHours).toFixed(2)}%`,
      },
      {
        title: "This Week",
        value: formatHours(Number( progressBar.week.hours) + elapsedHours),
        valuespan: ` / ${progressBar.week.targetHours} hrs`,
        progressBarColor: "bg-info",
        progressWidth: `${calcPercent(progressBar.week.hours, progressBar.week.targetHours).toFixed(2)}%`,
      },
      {
        title: "This Month",
        value: formatHours(Number(progressBar.month.hours) + elapsedHours),
        valuespan: ` / ${progressBar.month.targetHours} hrs`,
        progressBarColor: "bg-warning",
        progressWidth: `${calcPercent(progressBar.month.hours, progressBar.month.targetHours).toFixed(2)}%`,
      },
      {
        title: "Overtime (Month)",
        value:  progressBar.monthlyOvertime.hours,
        valuespan: "",
        progressBarColor: "bg-danger",
        progressWidth: progressBar.monthlyOvertime.hours,
      },
      {
        title: "Remaining (Month)",
        value: progressBar.monthlyRemaining.hours,
        valuespan: "",
        progressBarColor: "bg-secondary",
        progressWidth: `${(100 - calcPercent(progressBar.month.hours, progressBar.month.targetHours)).toFixed(2)}%`,
      },
    ]
    : [];


  useEffect(() => {
 const activities = progress?.records?.flatMap((record) => [
  {
    title: "Punch Out at",
    time: record.punchOut !== null ? dayjs(parseInt(record.punchOut)).format("hh:mm:ss a") : "pending",
  },
  {
    title: "Punch In at",
    time: dayjs(Number(record.punchIn)).format("hh:mm:ss a"),
  }
]);
    setActivity(activities);
  }, [progress]);
  const ID = lastAttendenceRecord?.id
  
const handleSubmitPunch = async () => {
    if (UserStatus) {
        await dispatch(attendanceUpdateAsync({
        id: ID,
        empid: loginUser?.id,
        input: {
          punchOut: Date.now().toString(),
          status: false,
        },
      }))
    } else {
       dispatch(attendenceLoginThunk(({
        empId: loginUser?.id,
        punchIn: Date.now().toString(),
      })))
   
    }
  }
 
 if (h >= 9){
    dispatch(setPunchInStatus(false))
       dispatch(attendanceUpdateAsync({
        id: ID,
        empid: loginUser?.id,
        input: {
          punchOut: Date.now().toString(),
          status: false,
        },
      }))
  }
  const getTodayBreakAndOvertime = (records) => {
    const today = moment().startOf('day');
    const endOfToday = moment().endOf('day');

    const todaysRecords = records.filter((record) => {
      const punchIn = parseInt(record.punchIn);
      return moment(punchIn).isBetween(today, endOfToday, null, '[]');
    });

    let totalBreakMs = 0;
    let totalOvertimeHrs = 0;

    todaysRecords.forEach((record) => {
      const punchIn = parseInt(record.punchIn);
      const punchOut = record.punchOut ? parseInt(record.punchOut) : null;
      const durationMs = punchOut ? punchOut - punchIn : 0;

      let recordBreakMs = 0;

      if (record.breaks?.length > 0) {
        record.breaks.forEach((b) => {
          if (b.breakIn && b.breakOut) {
            const breakIn = parseInt(b.breakIn);
            const breakOut = parseInt(b.breakOut);
            recordBreakMs += breakOut - breakIn;
          }
        });
      }

      const breakHours = recordBreakMs / (1000 * 60 * 60);
      totalBreakMs += recordBreakMs;

      const workHoursExcludingBreak = durationMs / (1000 * 60 * 60) - breakHours;
      const overtime = workHoursExcludingBreak > 9 ? workHoursExcludingBreak - 9 : 0;
      totalOvertimeHrs += overtime;
    });

    return {
      break: formatDuration(totalBreakMs),
      overtime: totalOvertimeHrs.toFixed(2),
    };

  };

  
 
 


  const todayStats = getTodayBreakAndOvertime(recordsToDisplay);
  return (
    <>
      <div className="page-wrapper">
        <div id="Attendence" className="card profile-box flex-fill">
          <div className="content container-fluid">
            <div className="row">
              <div className="col-md-4">
                <div className="card punch-status">
                  <div className="card-body">
                    <h5 className="card-title">
                      Timesheet <small className="text-muted">{moment(Date.now()).format("DD MMM YYYY ")}</small>
                    </h5>
                    <div className="punch-det">
                      <h6>Punch In at</h6>
                      <p>{lastAttendenceRecord?.punchIn ? moment(parseInt(lastAttendenceRecord?.punchIn)).format("DD MMM YYYY hh:mm A") : "Please punch in before starting your work."}</p>
                    </div>
                    <div className="punch-info">
                      <div className="punch-hours">
                        <span>{useElapsedTime(UserStatus)} hrs</span>
                      </div>
                    </div>
                    <div className="punch-btn-section">
                      <AntdButton label={UserStatus ? "Punch Out" : "Punch In"} type="primary" onClick={handleSubmitPunch} className="punch-btn" />
                    </div>
                    <div className="statistics">
                      <div className="row">
                        <div className="col-12 d-flex justify-content-between align-items-center">
                          <div className="stats-box">
                            <p>Break: {todayStats.break} hrs</p>
                          </div>
                          <div className="stats-box">
                            <p>Overtime: {todayStats.overtime} hrs</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card att-statistics">
                  <div className="card-body">
                    <h5 className="card-title">Statistics</h5>
                    <div className="stats-list">
                      {progressData.length > 0 ? (
                        progressData.map((data, index) => (
                          <div className="stats-info" key={index}>
                            <p>
                              {data.title}{" "}
                              <strong>
                                {data.value} <small>{data.valuespan}</small>
                              </strong>
                            </p>

                            <div className="progress" style={{ height: "8px" }}>
                              <div
                                className={`progress-bar ${data.progressBarColor}`}
                                role="progressbar"
                                style={{ width: data.progressWidth }}
                                aria-valuenow={parseFloat(data.progressWidth)}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                          </div>
                        ))
                      ) : (
                        <p>No data available</p>
                      )}
                    </div>
                  </div>

                </div>
              </div>
              <div className="col-md-4">
                <div className="card recent-activity">
                  <div className="card-body">
                    <h5 className="card-title">Latest Activity</h5>
                    <ul className="res-activity-list">
                      {Array.isArray(activity) && activity.length > 0 ? (
                        activity.map((activity, index) => (
                          <li key={index}>
                            <p className="mb-0">{activity.title}</p>
                            <p className="res-activity-time">
                              <i className="fa-regular fa-clock"></i>{" "}
                              {activity.time !== 'Invalid date' ? activity.time : 'pending'}
                            </p>
                          </li>
                        ))
                      ) : (
                        <p>No activities available.</p>
                      )}
                    </ul>
                  </div>
                </div>
              </div>
              <AttendanceEmployeeFilter
                userId={loginUser.id}
                pageSize={pageSize}
                setPage={setPage}
              />
              <div className="row">
                <div className="col-lg-12">
                  <div className="table-responsive">
                    <CustomGridTable
                      columns={column}
                      Id="attendence-employee-table"
                      dataSource={userElements?.length > 0 ? userElements : []}
                      className="table-striped"
                      rowKey={(record) => record.id}
                      pagination={{
                        current: page,
                        pageSize: pageSize,
                        onChange: (current, size) => handleTableChange({ current, pageSize: size }),
                        showQuickJumper: true,
                        showSizeChanger: false,
                        total: totalCount,
                        showTotal: (count, range) => `${range[0]}-${range[1]} of ${count}`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttendanceEmployee;

